import { ViewControllerPlugin } from '@absis/core-plugins';
import {
  NativeEvent,
  PluginResponse,
} from '@absis/core-plugins/dist/types/types/core-plugins-types';

export const CBViewController: ViewControllerPlugin = {
  closeWebView: () => {
    throw new Error(
      'CBViewController.closeWebView() is not supported for Desktop devices'
    );
  },
  navigateToIntegrationLayerID: () => {
    throw new Error(
      'CBViewController.navigateToIntegrationLayerID() is not supported for Desktop devices'
    );
  },
  launchNavToIL: (): Promise<PluginResponse<NativeEvent>> => {
    return Promise.reject(
      new Error(
        'CBViewController.launchNavToIL() is not supported for Desktop devices'
      )
    );
  },
  checkNavToIL: (): Promise<PluginResponse<NativeEvent>> => {
    return Promise.reject(
      new Error(
        'CBViewController.checkNavToIL() is not supported for Desktop devices'
      )
    );
  },
  spaNetworkStatus: () => {
    throw new Error(
      'CBViewController.spaNetworkStatus() is not supported for Desktop devices'
    );
  },
  checkDeepLink: () => {
    throw new Error(
      'CBViewController.checkDeepLink() is not supported for Desktop devices'
    );
  },
  launchDeepLink: () => {
    throw new Error(
      'CBViewController.launchDeepLink() is not supported for Desktop devices'
    );
  },
};
